var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tutorial-system"},[_c('TutorialOverlay',{attrs:{"is-active":_vm.isTutorialActive,"model-name":_vm.modelName,"tutorial-type":_vm.tutorialType},on:{"close-tutorial":_vm.deactivateTutorial,"tutorial-completed":_vm.handleTutorialCompleted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }